var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 门店数据加载组件（StoreDataLoader）
 *
 * 职责：
 * 1. 调用 useLoadingStoreData 获取单店数据（房态、渠道价、RevPAR、客源等）
 * 2. 将数据分发给各子组件（RoomStatus、ChannelPrice、CustomerSource 等）
 * 3. 按 focusComponentType 控制只展示指定组件（如 Genie 链接「只看房态」）
 * 4. 支持 bareLayout（独立页）、isScreenshotMode（无头截图）等模式
 *
 * 性能：
 * - 使用 React.memo 自定义比较：仅 storeId / refreshKey / storeName / bareLayout 变化时重渲染
 * - 各子组件从各自 hook 取数，数据更新不触发整树重渲染
 */
import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { getBusinessReportDailyWithCache } from "../utils/businessReportDailyCache";
import { buildStoreOverviewSnapshot, enrichStoreOverviewFromReportList, } from "../utils/buildStoreOverviewSnapshot";
import { ReloadOutlined } from "@ant-design/icons";
import { Spin, Typography } from "antd";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, } from "@dnd-kit/core";
import { SortableContext, rectSortingStrategy } from "@dnd-kit/sortable";
import { arrayMove } from "@dnd-kit/sortable";
import { ContainerPanel } from "@ms/shared-components";
import { DEFAULT_COMPONENT_ORDER, mergeComponentOrderWithDefaults, } from "../configs/componentOrder";
import { SortableComponentSlot } from "./SortableComponentSlot";
import { getComponentDataByTimeRanges } from '../../service/storeRevenueApi';
import { getComponentTimeDirection } from "../utils/componentTimeDirection";
import { storeComponentUsesTimeDirection } from "../utils/storeComponentBundle";
import { useLoadingStoreData, } from "../hooks/useLoadingStoreData";
import { useRoomStatusRecentlyData } from "./RoomStatusRecently/hooks/useRoomStatusRecentlyData";
import { createLogger } from "../utils/logger";
import { buildComponentDataPackage } from "../utils/buildComponentDataPackage";
import RoomStatus from "./RoomStatus";
import HourlyPriceByRoomType from "./HourlyPriceByRoomType";
import OrderTraffic from "./OrderTraffic";
import RoomStatusRecently from "./RoomStatusRecently";
import RevPARChart from "./RevPAR";
import ChannelInfoChart from "./ChannelInfo";
import ChannelPrice from "./ChannelPrice";
import RoomHealth from "./RoomHealth/index";
import CustomerSource from "./CustomerSource/index";
import DiscountAnalysis from "./DiscountAnalysis/index";
import ChannelAnalysis from "./ChannelAnalysis/index";
import OccupancyAnalysis from "./OccupancyAnalysis/index";
import OperationEfficiency from "./OperationEfficiency/index";
import StoreOverview from "./StoreOverview";
import { useStoreOverviewData } from "./StoreOverview/hooks/useStoreOverviewData";
import { useOrderRoomPresetData } from "../hooks/useOrderRoomPresetData";
import { sumOrderRoomListPrices } from "../utils/sumOrderRoomListPrices";
import { buildChannelCountsFromOrderRoomList } from "../utils/orderRoomChannelCounts";
var logger = createLogger("StoreRevenueMonitor.StoreDataLoader");
function bundleHasChartCategories(bundle) {
    var _a, _b;
    if (!bundle || typeof bundle !== "object")
        return false;
    var b = bundle;
    for (var _i = 0, _c = ["last7Days", "last30Days", "last12Months", "current"]; _i < _c.length; _i++) {
        var key = _c[_i];
        var cats = (_b = (_a = b[key]) === null || _a === void 0 ? void 0 : _a.chartData) === null || _b === void 0 ? void 0 : _b.categories;
        if (Array.isArray(cats) && cats.length > 0)
            return true;
    }
    return false;
}
/** 截图就绪：focus 组件在 storeData 中已有可绘制数据（与 useLoadingStoreData.hasDataFor 对齐） */
function focusScreenshotHasRenderableData(focusType, storeData) {
    var _a, _b, _c;
    switch (focusType) {
        case "room-status":
            return ((_c = (_b = (_a = storeData.roomStatus) === null || _a === void 0 ? void 0 : _a.dataSource) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0;
        case "channel-analysis":
            return bundleHasChartCategories(storeData.channelAnalysisBundle);
        case "channel-info":
            return bundleHasChartCategories(storeData.channelInfoBundle);
        case "order-traffic":
            return bundleHasChartCategories(storeData.orderTrafficBundle);
        case "room-health":
            return bundleHasChartCategories(storeData.roomHealthBundle);
        case "customer-source":
            return bundleHasChartCategories(storeData.customerSourceBundle);
        case "discount-analysis":
            return bundleHasChartCategories(storeData.discountAnalysisBundle);
        case "occupancy-analysis":
            return bundleHasChartCategories(storeData.occupancyAnalysisBundle);
        case "operation-efficiency":
            return bundleHasChartCategories(storeData.operationEfficiencyBundle);
        case "revpar":
            return bundleHasChartCategories(storeData.revparBundle);
        default:
            return true;
    }
}
/** 与 OrderRoomPreset / msCentral proxy 一致；5 = 已退房 */
function roomStatusOfRowFsm(r) {
    var _a, _b;
    var n = Number((_b = (_a = r.roomStatus) !== null && _a !== void 0 ? _a : r.room_status) !== null && _b !== void 0 ? _b : -999);
    return Number.isFinite(n) ? n : -999;
}
var wrapLayoutGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(max(380px, calc((100% - 32px) / 3)), 1fr))",
    gap: "16px",
    width: "100%",
    /** 禁止同行最高卡片把其它格子纵向拉满，避免「空高度」与整页被间接撑高 */
    alignItems: "start",
    /** 隐式行高随内容，减少 fr/拉伸带来的额外行高 */
    gridAutoRows: "min-content",
};
/**
 * 门店数据加载组件（用于在 map 中使用 hook）
 * 使用 React.memo 防止不必要的重新渲染
 * 只有当 storeId、storeName 或 refreshKey 真正变化时才重新渲染
 */
var StoreDataLoader = React.memo(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var storeId = _a.storeId, storeName = _a.storeName, refreshKey = _a.refreshKey, focusComponentType = _a.focusComponentType, onTitleClick = _a.onTitleClick, onRefresh = _a.onRefresh, onComponentTitleClick = _a.onComponentTitleClick, onDataLoaded = _a.onDataLoaded, onStoreDataReady = _a.onStoreDataReady, registerRefresh = _a.registerRefresh, unregisterRefresh = _a.unregisterRefresh, _m = _a.bareLayout, bareLayout = _m === void 0 ? false : _m, _o = _a.flatChrome, flatChrome = _o === void 0 ? false : _o, onRefreshReady = _a.onRefreshReady, _p = _a.isScreenshotMode, isScreenshotMode = _p === void 0 ? false : _p, screenshotDateRange = _a.screenshotDateRange, screenshotOrderTrafficGranularity = _a.screenshotOrderTrafficGranularity, _q = _a.wrapLayout, wrapLayout = _q === void 0 ? false : _q, _r = _a.hideStoreName, hideStoreName = _r === void 0 ? false : _r, _s = _a.draggable, draggable = _s === void 0 ? false : _s, componentOrder = _a.componentOrder, onComponentOrderChange = _a.onComponentOrderChange;
    // 使用 hook 获取该门店的所有数据（直接生成 mock 数据，完全隔离）
    // 关键：每个门店使用独立的 storeId，刷新完全由内部的 refresh 函数管理
    // 注意：refreshKey prop 只用于 React.memo 比较，实际刷新不依赖它
    var _t = useLoadingStoreData({
        storeId: storeId,
        focusComponentType: focusComponentType !== null && focusComponentType !== void 0 ? focusComponentType : null,
        isScreenshotMode: isScreenshotMode,
        // 不传入 refreshKey，让 useLoadingStoreData 完全独立管理刷新
    }), refreshStoreData = _t.refresh, loading = _t.loading, loadError = _t.error, rawStoreData = _t.storeData, _u = _t.componentStatus, componentStatus = _u === void 0 ? {} : _u, storeData = __rest(_t, ["refresh", "loading", "error", "storeData", "componentStatus"]);
    // 各组件从各自 hook 取数（hook 内从 storeData 取对应片段）
    var storeDataForHooks = rawStoreData !== null && rawStoreData !== void 0 ? rawStoreData : null;
    var roomStatusRecentlyData = useRoomStatusRecentlyData(storeDataForHooks);
    var needStoreOverviewRelated = !isScreenshotMode || focusComponentType === "store-overview";
    var storeOverview = useStoreOverviewData(storeId, (_c = (_b = storeDataForHooks === null || storeDataForHooks === void 0 ? void 0 : storeDataForHooks.roomStatus) === null || _b === void 0 ? void 0 : _b.dataSource) !== null && _c !== void 0 ? _c : [], { enabled: needStoreOverviewRelated });
    var inHouseFsmPreset = useOrderRoomPresetData(storeId, "in-house-today", {
        enabled: needStoreOverviewRelated,
    });
    var expectedArrivalFsmPreset = useOrderRoomPresetData(storeId, "expected-arrival-today", { enabled: needStoreOverviewRelated });
    var expectedDepartureFsmPreset = useOrderRoomPresetData(storeId, "expected-departure-today", { enabled: needStoreOverviewRelated });
    var fsmInHouseCount = inHouseFsmPreset.data != null &&
        Number.isFinite(inHouseFsmPreset.data.total)
        ? inHouseFsmPreset.data.total
        : undefined;
    var fsmExpectedArrivalCount = useMemo(function () {
        var _a;
        var d = expectedArrivalFsmPreset.data;
        if (!d)
            return undefined;
        var fromSummary = (_a = d.summary) === null || _a === void 0 ? void 0 : _a.roomStatus01Total;
        if (typeof fromSummary === "number" && Number.isFinite(fromSummary)) {
            return fromSummary;
        }
        return Number.isFinite(d.total) ? d.total : undefined;
    }, [expectedArrivalFsmPreset.data]);
    var fsmSellableQuantityOpen = useMemo(function () {
        var _a, _b, _c;
        var ds = (_b = (_a = storeDataForHooks === null || storeDataForHooks === void 0 ? void 0 : storeDataForHooks.roomStatus) === null || _a === void 0 ? void 0 : _a.dataSource) !== null && _b !== void 0 ? _b : [];
        if (!Array.isArray(ds) || ds.length === 0)
            return undefined;
        var storeTotal = ds.find(function (r) { return r.isStoreTotal; });
        var aggOpenRaw = storeTotal === null || storeTotal === void 0 ? void 0 : storeTotal.quantityOpen;
        var aggOpen = aggOpenRaw != null && Number.isFinite(Number(aggOpenRaw))
            ? Math.max(0, Math.round(Number(aggOpenRaw)))
            : null;
        var sum = 0;
        var hasType = false;
        for (var _i = 0, ds_1 = ds; _i < ds_1.length; _i++) {
            var r = ds_1[_i];
            if (r.isStoreTotal)
                continue;
            hasType = true;
            sum += Math.max(0, Math.round(Number((_c = r.quantityOpen) !== null && _c !== void 0 ? _c : 0)));
        }
        if (!hasType) {
            return aggOpen != null && aggOpen > 0 ? aggOpen : undefined;
        }
        if (sum === 0 && aggOpen != null && aggOpen > 0) {
            return aggOpen;
        }
        return sum;
    }, [(_d = storeDataForHooks === null || storeDataForHooks === void 0 ? void 0 : storeDataForHooks.roomStatus) === null || _d === void 0 ? void 0 : _d.dataSource]);
    var _v = useMemo(function () {
        var d = expectedDepartureFsmPreset.data;
        if (d == null) {
            return {
                fsmPredDepartCount: undefined,
                fsmEarlyCheckoutCount: undefined,
            };
        }
        var s = d.summary;
        var p = s === null || s === void 0 ? void 0 : s.predDepartCount;
        var e = s === null || s === void 0 ? void 0 : s.earlyCheckoutCount;
        if (typeof p === "number" &&
            Number.isFinite(p) &&
            typeof e === "number" &&
            Number.isFinite(e)) {
            return {
                fsmPredDepartCount: Math.max(0, Math.round(p)),
                fsmEarlyCheckoutCount: Math.max(0, Math.round(e)),
            };
        }
        var list = d.list;
        if (!(list === null || list === void 0 ? void 0 : list.length)) {
            return { fsmPredDepartCount: 0, fsmEarlyCheckoutCount: 0 };
        }
        var pred = 0;
        var early = 0;
        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
            var r = list_1[_i];
            if (roomStatusOfRowFsm(r) === 5)
                early += 1;
            else
                pred += 1;
        }
        return { fsmPredDepartCount: pred, fsmEarlyCheckoutCount: early };
    }, [expectedDepartureFsmPreset.data]), fsmPredDepartCount = _v.fsmPredDepartCount, fsmEarlyCheckoutCount = _v.fsmEarlyCheckoutCount;
    var predictedRevenueOrderSum = useMemo(function () {
        var _a, _b;
        if (inHouseFsmPreset.loading || expectedArrivalFsmPreset.loading) {
            return undefined;
        }
        var listA = (_a = inHouseFsmPreset.data) === null || _a === void 0 ? void 0 : _a.list;
        var listB = (_b = expectedArrivalFsmPreset.data) === null || _b === void 0 ? void 0 : _b.list;
        var a = sumOrderRoomListPrices(listA);
        var b = sumOrderRoomListPrices(listB);
        var sum = Math.round((a + b) * 100) / 100;
        if (sum === 0) {
            return undefined;
        }
        return sum;
    }, [
        inHouseFsmPreset.loading,
        inHouseFsmPreset.data,
        expectedArrivalFsmPreset.loading,
        expectedArrivalFsmPreset.data,
    ]);
    var inHouseChannelCounts = useMemo(function () {
        var _a;
        return buildChannelCountsFromOrderRoomList((_a = inHouseFsmPreset.data) === null || _a === void 0 ? void 0 : _a.list);
    }, [inHouseFsmPreset.data]);
    var expectedArrivalChannelCounts = useMemo(function () {
        var _a;
        return buildChannelCountsFromOrderRoomList((_a = expectedArrivalFsmPreset.data) === null || _a === void 0 ? void 0 : _a.list);
    }, [expectedArrivalFsmPreset.data]);
    var storeDataWithOverview = useMemo(function () {
        return rawStoreData
            ? __assign(__assign({}, rawStoreData), { storeOverview: storeOverview.snapshot }) : null;
    }, [rawStoreData, storeOverview.snapshot]);
    /** 单店网格：避免 CompsTable autoScroll 与 Splitter/flex 未约束时互相撑高整页 */
    var disableTableAutoScroll = Boolean(wrapLayout && bareLayout);
    // 按组件取状态：无记录时若整体 loading 则为 loading，否则为 success（如缓存命中）
    var getStatus = useCallback(function (type) {
        var _a;
        if (type === "store-overview") {
            return storeOverview.loading ? "loading" : "success";
        }
        return (_a = componentStatus[type]) !== null && _a !== void 0 ? _a : (loading ? "loading" : "success");
    }, [componentStatus, loading, storeOverview.loading]);
    /**
     * 单组件槽位渲染：根据 componentStatus 展示 loading / success / failed / timeout
     * 截图模式且为 focus 组件时，无论状态如何都渲染 content，确保 DOM 有 data-component-id 供 Puppeteer 定位
     */
    var slotWrapper = useCallback(function (inner) { return (_jsx("div", __assign({ style: {
            minWidth: bareLayout ? undefined : 300,
            /** wrapLayout+bareLayout：由子卡片自身高度决定，避免再叠一层 min 参与 grid 行高膨胀 */
            minHeight: bareLayout && wrapLayout ? 0 : 300,
            flexShrink: bareLayout ? 1 : 0,
            width: bareLayout ? "100%" : undefined,
            boxSizing: "border-box",
        } }, { children: inner }))); }, [bareLayout, wrapLayout]);
    var renderSlot = useCallback(function (type, content) {
        var status = getStatus(type);
        var isFocusForScreenshot = isScreenshotMode && type === focusComponentType;
        if (isFocusForScreenshot) {
            return (_jsx("div", __assign({ "data-screenshot-component-type": type, "data-screenshot-component-ready": status === "loading" ? "0" : "1" }, { children: slotWrapper(content) })));
        }
        if (status === "loading") {
            return (_jsx("div", __assign({ style: {
                    minWidth: 300,
                    minHeight: 300,
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                } }, { children: _jsx(Spin, { className: "store-data-loader-spin", tip: "\u52A0\u8F7D\u4E2D\u2026" }) })));
        }
        if (status === "failed") {
            return (_jsx("div", __assign({ style: {
                    minWidth: 300,
                    minHeight: 300,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#ff4d4f",
                } }, { children: _jsx(Typography.Text, { children: "\u52A0\u8F7D\u5931\u8D25" }) })));
        }
        if (status === "timeout") {
            return (_jsx("div", __assign({ style: {
                    minWidth: 300,
                    minHeight: 300,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#faad14",
                } }, { children: _jsx(Typography.Text, { children: "\u8BF7\u6C42\u8D85\u65F6" }) })));
        }
        return slotWrapper(content);
    }, [getStatus, isScreenshotMode, focusComponentType, slotWrapper]);
    // 注册刷新函数到注册表（用于自动刷新）
    useEffect(function () {
        if (registerRefresh) {
            registerRefresh(storeId, refreshStoreData);
        }
        return function () {
            if (unregisterRefresh) {
                unregisterRefresh(storeId);
            }
        };
    }, [storeId, refreshStoreData, registerRefresh, unregisterRefresh]);
    // 使用 ref 存储 onDataLoaded，避免依赖变化导致重新渲染
    var onDataLoadedRef = useRef(onDataLoaded);
    onDataLoadedRef.current = onDataLoaded;
    // 截图模式：按 focus 组件状态标记 ready/state，避免过早截图（房态/图表类尤甚）。
    useEffect(function () {
        if (typeof document === "undefined" || !isScreenshotMode || !focusComponentType)
            return;
        var status = getStatus(focusComponentType);
        var hasRenderableData = focusScreenshotHasRenderableData(focusComponentType, storeData);
        var screenshotState = status === "success"
            ? (hasRenderableData ? "success" : "empty")
            : status === "failed" || status === "timeout"
                ? status
                : "loading";
        document.body.dataset.screenshotState = screenshotState;
        document.body.dataset.screenshotHasData = hasRenderableData ? "1" : "0";
        document.body.dataset.screenshotReady = screenshotState === "loading" ? "0" : "1";
        document.body.dataset.screenshotComponentType = focusComponentType;
        document.body.dataset.screenshotComponentReady = screenshotState === "loading" ? "0" : "1";
    }, [
        focusComponentType,
        getStatus,
        isScreenshotMode,
        (_f = (_e = storeData.roomStatus) === null || _e === void 0 ? void 0 : _e.dataSource) === null || _f === void 0 ? void 0 : _f.length,
        storeData.channelAnalysisBundle,
        storeData.channelInfoBundle,
        storeData.orderTrafficBundle,
        storeData.roomHealthBundle,
        storeData.customerSourceBundle,
        storeData.discountAnalysisBundle,
        storeData.occupancyAnalysisBundle,
        storeData.operationEfficiencyBundle,
        storeData.revparBundle,
    ]);
    // 监听请求结束（loading 从 true 变为 false），必须触发 onDataLoaded，以便 loadNextBatch 继续加载下一店；
    // 若仅在有 roomStatus.dataSource 时才调用，某店无房态数据时不会触发，会导致「5 个之后卡住」
    var prevLoadingRef = useRef(true);
    var storeLogger = useMemo(function () { return logger.createChild("render:".concat(storeId)); }, [storeId]);
    useEffect(function () {
        var _a;
        if (prevLoadingRef.current && !loading) {
            storeLogger.info("请求结束，触发 onDataLoaded（继续加载下一店）");
            (_a = onDataLoadedRef.current) === null || _a === void 0 ? void 0 : _a.call(onDataLoadedRef, storeId);
        }
        prevLoadingRef.current = loading;
    }, [loading, storeId, storeLogger]);
    // 数据就绪时通知父组件（供独立组件页 AI 分析使用）
    var onStoreDataReadyRef = useRef(onStoreDataReady);
    onStoreDataReadyRef.current = onStoreDataReady;
    useEffect(function () {
        var _a;
        if (rawStoreData) {
            (_a = onStoreDataReadyRef.current) === null || _a === void 0 ? void 0 : _a.call(onStoreDataReadyRef, __assign(__assign({}, rawStoreData), { storeOverview: storeOverview.snapshot }));
        }
    }, [rawStoreData, storeOverview.snapshot]);
    // 添加日志，检查组件是否被重新渲染（即使 props 没变）
    storeLogger.debug("组件执行", {
        refreshKey: refreshKey,
        dataSourceLength: ((_h = (_g = storeData.roomStatus) === null || _g === void 0 ? void 0 : _g.dataSource) === null || _h === void 0 ? void 0 : _h.length) || 0,
        note: "如果 props 没变但组件执行了，说明父组件重新渲染了",
    });
    // 使用 useMemo 稳定回调函数，避免每次渲染都创建新函数
    var handleTitleClick = useCallback(function () {
        onTitleClick();
    }, [onTitleClick]);
    var handleRefresh = useCallback(function () {
        // 只调用 hook 内部的刷新函数，不调用外部的刷新函数
        // 这样可以完全避免触发全局重新渲染
        refreshStoreData(); // 调用 hook 的刷新函数，更新 internalRefreshKey，触发数据重新生成
        // 注意：不再调用 onRefresh()，避免触发外部的 refreshStore，导致全局重新渲染
    }, [refreshStoreData]);
    // bareLayout 时把刷新函数传给父组件，让父组件在底部统一渲染刷新+AI分析按钮
    useEffect(function () {
        if (bareLayout && onRefreshReady) {
            onRefreshReady(handleRefresh);
        }
    }, [bareLayout, onRefreshReady, handleRefresh]);
    var numericStoreId = typeof storeId === "string" ? Number.parseInt(storeId, 10) : storeId;
    var handleComponentTitleClick = useCallback(function (params) {
        var _a;
        onComponentTitleClick({
            storeId: params.storeId,
            storeName: (_a = params.storeName) !== null && _a !== void 0 ? _a : storeName,
            componentType: params.componentType,
            componentData: params.componentData,
            storeData: params.storeData,
        });
    }, [onComponentTitleClick, storeName]);
    /** 组件标题点击：优先调后端 getComponentDataByTimeRanges 取四段时间数据；失败时降级为 buildComponentDataPackage 本地打包 */
    var createTitleClickHandler = useCallback(function (componentType) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, timeDirection, list, sorted, snap, pkg, err_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    data = (storeDataWithOverview !== null && storeDataWithOverview !== void 0 ? storeDataWithOverview : storeData);
                    if (!storeComponentUsesTimeDirection(componentType)) {
                        handleComponentTitleClick({
                            storeId: numericStoreId,
                            storeName: storeName,
                            componentType: componentType,
                            componentData: buildComponentDataPackage(storeId, componentType, data),
                            storeData: data,
                        });
                        return [2 /*return*/];
                    }
                    timeDirection = getComponentTimeDirection(componentType);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 5, , 6]);
                    if (!(componentType === "store-overview")) return [3 /*break*/, 3];
                    return [4 /*yield*/, getBusinessReportDailyWithCache(storeId)];
                case 2:
                    list = _e.sent();
                    sorted = __spreadArray([], list, true).sort(function (a, b) { return (b.date || 0) - (a.date || 0); });
                    snap = enrichStoreOverviewFromReportList(list, buildStoreOverviewSnapshot(sorted[0], (_b = (_a = rawStoreData === null || rawStoreData === void 0 ? void 0 : rawStoreData.roomStatus) === null || _a === void 0 ? void 0 : _a.dataSource) !== null && _b !== void 0 ? _b : []));
                    handleComponentTitleClick({
                        storeId: numericStoreId,
                        storeName: storeName,
                        componentType: componentType,
                        componentData: { timeDirection: timeDirection, current: snap },
                        storeData: storeDataWithOverview !== null && storeDataWithOverview !== void 0 ? storeDataWithOverview : storeData,
                    });
                    return [2 /*return*/];
                case 3: return [4 /*yield*/, getComponentDataByTimeRanges(storeId, componentType, timeDirection)];
                case 4:
                    pkg = _e.sent();
                    if (componentType === "room-status" &&
                        ((_d = (_c = rawStoreData === null || rawStoreData === void 0 ? void 0 : rawStoreData.roomStatus) === null || _c === void 0 ? void 0 : _c.dataSource) === null || _d === void 0 ? void 0 : _d.length)) {
                        pkg.current = rawStoreData.roomStatus;
                    }
                    handleComponentTitleClick({
                        storeId: numericStoreId,
                        storeName: storeName,
                        componentType: componentType,
                        componentData: pkg,
                        storeData: storeDataWithOverview !== null && storeDataWithOverview !== void 0 ? storeDataWithOverview : storeData,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _e.sent();
                    storeLogger.warn("组件四段数据接口失败，降级为本地数据", {
                        componentType: componentType,
                        error: err_1,
                    });
                    handleComponentTitleClick({
                        storeId: numericStoreId,
                        storeName: storeName,
                        componentType: componentType,
                        componentData: buildComponentDataPackage(storeId, componentType, (storeDataWithOverview !== null && storeDataWithOverview !== void 0 ? storeDataWithOverview : storeData), timeDirection),
                        storeData: storeDataWithOverview !== null && storeDataWithOverview !== void 0 ? storeDataWithOverview : storeData,
                    });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); }; }, [
        storeId,
        numericStoreId,
        storeName,
        storeData,
        storeDataWithOverview,
        rawStoreData,
        handleComponentTitleClick,
        storeLogger,
    ]);
    var handleStoreOverviewTitleClick = createTitleClickHandler("store-overview");
    var handleRoomStatusTitleClick = createTitleClickHandler("room-status");
    var handleOrderTrafficTitleClick = createTitleClickHandler("order-traffic");
    var handleRoomStatusRecentlyTitleClick = createTitleClickHandler("room-status-recently");
    var handleRevPARTitleClick = createTitleClickHandler("revpar");
    var handleChannelInfoTitleClick = createTitleClickHandler("channel-info");
    var handleChannelAnalysisTitleClick = createTitleClickHandler("channel-analysis");
    var handleChannelPriceTitleClick = createTitleClickHandler("channel-price");
    // 构建标题：hotelId - 酒店名称（名称为空时显示「门店{id」），包含加载动画；hideStoreName 时隐藏门店名称
    var displayName = (storeName === null || storeName === void 0 ? void 0 : storeName.trim()) || "\u95E8\u5E97".concat(storeId);
    var titleWithLoading = hideStoreName ? (loading ? _jsx(Spin, { size: "small" }) : "") : (_jsxs("span", __assign({ style: { display: "flex", alignItems: "center", gap: "8px" } }, { children: [_jsxs("span", { children: [storeId, " - ", displayName] }), loading && _jsx(Spin, { size: "small" })] })));
    var wrapSlot = useMemo(function () {
        if (bareLayout)
            return function (node) { return _jsx("div", __assign({ style: { width: "100%" } }, { children: node })); };
        if (wrapLayout)
            return function (node) { return _jsx("div", __assign({ style: { width: "100%", minWidth: 0 } }, { children: node })); };
        return function (n) { return n; };
    }, [bareLayout, wrapLayout]);
    var fullWidthStyle = useMemo(function () {
        if (!bareLayout && !wrapLayout)
            return undefined;
        var base = { width: "100%", boxSizing: "border-box" };
        if (!flatChrome)
            return base;
        return __assign(__assign({}, base), { border: "none", borderRadius: 0, background: "#ffffff", boxShadow: "none" });
    }, [bareLayout, wrapLayout, flatChrome]);
    // 拖拽排序：有效顺序（去重、非法 id 过滤，并与默认合并补全）
    var effectiveOrder = useMemo(function () { return mergeComponentOrderWithDefaults(componentOrder, DEFAULT_COMPONENT_ORDER); }, [componentOrder]);
    var sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 8 } }), useSensor(KeyboardSensor));
    var handleDragEnd = useCallback(function (event) {
        var active = event.active, over = event.over;
        if (!over || active.id === over.id || !onComponentOrderChange)
            return;
        var oldIndex = effectiveOrder.indexOf(String(active.id));
        var newIndex = effectiveOrder.indexOf(String(over.id));
        if (oldIndex === -1 || newIndex === -1)
            return;
        var next = arrayMove(effectiveOrder, oldIndex, newIndex);
        onComponentOrderChange(next);
    }, [effectiveOrder, onComponentOrderChange]);
    /** 根据类型返回对应的 slot 内容（用于拖拽模式按序渲染） */
    var buildSlotForType = useCallback(function (type) {
        var _a, _b;
        if (focusComponentType && type !== focusComponentType)
            return null;
        var slots = {
            "store-overview": renderSlot("store-overview", _jsx(StoreOverview, { snapshot: storeOverview.snapshot, fsmInHouseCount: fsmInHouseCount, fsmExpectedArrivalCount: fsmExpectedArrivalCount, fsmSellableQuantityOpen: fsmSellableQuantityOpen, fsmPredDepartCount: fsmPredDepartCount, fsmEarlyCheckoutCount: fsmEarlyCheckoutCount, predictedRevenueOrderSum: predictedRevenueOrderSum, inHouseChannelCounts: inHouseChannelCounts, expectedArrivalChannelCounts: expectedArrivalChannelCounts, loading: storeOverview.loading, error: storeOverview.error, onTitleClick: handleStoreOverviewTitleClick, style: fullWidthStyle })),
            "order-traffic": renderSlot("order-traffic", _jsx(OrderTraffic, { storeId: storeId, bundle: storeData.orderTrafficBundle, loading: componentStatus["order-traffic"] === "loading", onTitleClick: handleOrderTrafficTitleClick, style: fullWidthStyle, initialGranularity: screenshotOrderTrafficGranularity === "天"
                    ? "天"
                    : screenshotOrderTrafficGranularity === "小时"
                        ? "小时"
                        : undefined })),
            "room-status": renderSlot("room-status", _jsx(RoomStatus, { dataSource: storeData.roomStatus.dataSource, columns: storeData.roomStatus.columns, storeId: storeId, onTitleClick: handleRoomStatusTitleClick, style: fullWidthStyle, disableTableAutoScroll: disableTableAutoScroll, hideHeaderTitle: isScreenshotMode })),
            "room-status-recently": renderSlot("room-status-recently", _jsx(RoomStatusRecently, { storeId: storeId, roomStatusRecentlyData: roomStatusRecentlyData, onTitleClick: handleRoomStatusRecentlyTitleClick, style: fullWidthStyle })),
            "room-health": renderSlot("room-health", _jsx(RoomHealth, { bundle: storeData.roomHealthBundle, style: fullWidthStyle })),
            "hourly-price-by-room": renderSlot("hourly-price-by-room", _jsx(HourlyPriceByRoomType, { dataSource: (_b = (_a = storeData.hourlyPriceByRoom) === null || _a === void 0 ? void 0 : _a.dataSource) !== null && _b !== void 0 ? _b : [], onTitleClick: handleRoomStatusTitleClick, style: fullWidthStyle, disableTableAutoScroll: disableTableAutoScroll })),
            "channel-price": renderSlot("channel-price", _jsx(ChannelPrice, { storeId: storeId, channelPriceData: storeData.channelPrice.rawData, onTitleClick: handleChannelPriceTitleClick, style: fullWidthStyle })),
            revpar: renderSlot("revpar", _jsx(RevPARChart, { storeId: storeId, bundle: storeData.revparBundle, loading: componentStatus["revpar"] === "loading", onTitleClick: handleRevPARTitleClick, style: fullWidthStyle })),
            "customer-source": renderSlot("customer-source", _jsx(CustomerSource, { storeId: storeId, bundle: storeData.customerSourceBundle, loading: componentStatus["customer-source"] === "loading", style: fullWidthStyle })),
            "discount-analysis": renderSlot("discount-analysis", _jsx(DiscountAnalysis, { storeId: storeId, bundle: storeData.discountAnalysisBundle, loading: componentStatus["discount-analysis"] === "loading", style: fullWidthStyle })),
            "occupancy-analysis": renderSlot("occupancy-analysis", _jsx(OccupancyAnalysis, { bundle: storeData.occupancyAnalysisBundle, style: fullWidthStyle })),
            "operation-efficiency": renderSlot("operation-efficiency", _jsx(OperationEfficiency, { storeId: storeId, bundle: storeData.operationEfficiencyBundle, loading: componentStatus["operation-efficiency"] === "loading", style: fullWidthStyle })),
            "channel-info": renderSlot("channel-info", _jsx(ChannelInfoChart, { storeId: storeId, bundle: storeData.channelInfoBundle, loading: componentStatus["channel-info"] === "loading", onTitleClick: handleChannelInfoTitleClick, style: fullWidthStyle })),
            "channel-analysis": renderSlot("channel-analysis", _jsx(ChannelAnalysis, { storeId: storeId, bundle: storeData.channelAnalysisBundle, loading: componentStatus["channel-analysis"] === "loading", onTitleClick: handleChannelAnalysisTitleClick, style: fullWidthStyle })),
        };
        var content = slots[type];
        return content ? wrapSlot(content) : null;
    }, [
        focusComponentType,
        renderSlot,
        wrapSlot,
        storeId,
        storeOverview.snapshot,
        storeOverview.loading,
        storeOverview.error,
        fsmInHouseCount,
        fsmExpectedArrivalCount,
        fsmSellableQuantityOpen,
        fsmPredDepartCount,
        fsmEarlyCheckoutCount,
        predictedRevenueOrderSum,
        inHouseChannelCounts,
        expectedArrivalChannelCounts,
        handleStoreOverviewTitleClick,
        storeData.orderTrafficBundle,
        handleOrderTrafficTitleClick,
        handleRoomStatusTitleClick,
        handleRoomStatusRecentlyTitleClick,
        handleChannelPriceTitleClick,
        handleChannelInfoTitleClick,
        handleRevPARTitleClick,
        handleChannelAnalysisTitleClick,
        storeData,
        roomStatusRecentlyData,
        storeData.roomHealthBundle,
        storeData.customerSourceBundle,
        storeData.discountAnalysisBundle,
        storeData.occupancyAnalysisBundle,
        storeData.operationEfficiencyBundle,
        storeData.channelInfoBundle,
        storeData.revparBundle,
        storeData.channelAnalysisBundle,
        componentStatus,
        fullWidthStyle,
        loadError,
        screenshotOrderTrafficGranularity,
        screenshotDateRange,
        disableTableAutoScroll,
    ]);
    var gridContent = wrapLayout && draggable && !focusComponentType ? (_jsx(DndContext, __assign({ sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd }, { children: _jsx(SortableContext, __assign({ items: effectiveOrder, strategy: rectSortingStrategy }, { children: effectiveOrder.map(function (id) {
                var slot = buildSlotForType(id);
                if (!slot)
                    return null;
                return (_jsx(SortableComponentSlot, __assign({ id: id }, { children: slot }), id));
            }) })) }))) : null;
    /** 单店 wrapLayout+bareLayout：不设 minHeight，避免 flex/grid 的 min-content 把滚动区越顶越高 */
    var flowMinHeight = bareLayout && wrapLayout ? 0 : bareLayout || wrapLayout ? 200 : undefined;
    var innerContent = (_jsx("div", __assign({ style: {
            width: "100%",
            height: bareLayout || wrapLayout ? "auto" : "300px",
            minHeight: flowMinHeight,
        } }, { children: _jsx("div", __assign({ style: {
                width: "100%",
                height: bareLayout || wrapLayout ? "auto" : "100%",
                minHeight: flowMinHeight,
                overflow: wrapLayout ? "visible" : "auto",
            } }, { children: loadError && !loading ? (_jsxs("div", __assign({ style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: 8,
                    height: "100%",
                    padding: 24,
                } }, { children: [_jsx(Typography.Text, __assign({ type: "warning", style: { fontSize: 14 } }, { children: ((_j = loadError.message) === null || _j === void 0 ? void 0 : _j.includes("请求超时"))
                            ? "请求超时"
                            : "加载失败" })), _jsx(Typography.Text, __assign({ type: "secondary", style: { fontSize: 12 } }, { children: "\u8BF7\u70B9\u51FB\u53F3\u4E0A\u89D2\u300C\u5237\u65B0\u300D\u91CD\u8BD5" }))] }))) : gridContent ? (_jsx("div", __assign({ style: wrapLayoutGridStyle }, { children: gridContent }))) : (_jsxs("div", __assign({ style: wrapLayout
                    ? wrapLayoutGridStyle
                    : {
                        display: "flex",
                        gap: "16px",
                        height: "100%",
                        alignItems: "flex-start",
                        padding: 0,
                        flexShrink: bareLayout ? 1 : 0,
                        minWidth: bareLayout ? undefined : "fit-content",
                        width: bareLayout ? "100%" : undefined,
                        flexDirection: bareLayout ? "column" : undefined,
                    } }, { children: [(!focusComponentType ||
                        focusComponentType === "store-overview") &&
                        wrapSlot(renderSlot("store-overview", _jsx(StoreOverview, { snapshot: storeOverview.snapshot, fsmInHouseCount: fsmInHouseCount, fsmExpectedArrivalCount: fsmExpectedArrivalCount, fsmSellableQuantityOpen: fsmSellableQuantityOpen, fsmPredDepartCount: fsmPredDepartCount, fsmEarlyCheckoutCount: fsmEarlyCheckoutCount, predictedRevenueOrderSum: predictedRevenueOrderSum, inHouseChannelCounts: inHouseChannelCounts, expectedArrivalChannelCounts: expectedArrivalChannelCounts, loading: storeOverview.loading, error: storeOverview.error, onTitleClick: handleStoreOverviewTitleClick, style: fullWidthStyle }))), (!focusComponentType ||
                        focusComponentType === "order-traffic") &&
                        wrapSlot(renderSlot("order-traffic", _jsx(OrderTraffic, { storeId: storeId, bundle: storeData.orderTrafficBundle, loading: componentStatus["order-traffic"] === "loading", onTitleClick: handleOrderTrafficTitleClick, style: fullWidthStyle, initialGranularity: screenshotOrderTrafficGranularity === "天"
                                ? "天"
                                : screenshotOrderTrafficGranularity === "小时"
                                    ? "小时"
                                    : undefined }))), (!focusComponentType || focusComponentType === "room-status") &&
                        wrapSlot(renderSlot("room-status", _jsx(RoomStatus, { dataSource: storeData.roomStatus.dataSource, columns: storeData.roomStatus.columns, storeId: storeId, onTitleClick: handleRoomStatusTitleClick, style: fullWidthStyle, disableTableAutoScroll: disableTableAutoScroll }))), (!focusComponentType ||
                        focusComponentType === "room-status-recently") &&
                        wrapSlot(renderSlot("room-status-recently", _jsx(RoomStatusRecently, { storeId: storeId, roomStatusRecentlyData: roomStatusRecentlyData, onTitleClick: handleRoomStatusRecentlyTitleClick, style: fullWidthStyle }))), (!focusComponentType || focusComponentType === "room-health") &&
                        wrapSlot(renderSlot("room-health", _jsx(RoomHealth, { bundle: storeData.roomHealthBundle, style: fullWidthStyle }))), (!focusComponentType || focusComponentType === "hourly-price-by-room") &&
                        wrapSlot(renderSlot("hourly-price-by-room", _jsx(HourlyPriceByRoomType, { dataSource: (_l = (_k = storeData.hourlyPriceByRoom) === null || _k === void 0 ? void 0 : _k.dataSource) !== null && _l !== void 0 ? _l : [], onTitleClick: handleRoomStatusTitleClick, style: fullWidthStyle, disableTableAutoScroll: disableTableAutoScroll }))), (!focusComponentType ||
                        focusComponentType === "channel-price") &&
                        wrapSlot(renderSlot("channel-price", _jsx(ChannelPrice, { storeId: storeId, channelPriceData: storeData.channelPrice.rawData, onTitleClick: handleChannelPriceTitleClick, style: fullWidthStyle }))), (!focusComponentType || focusComponentType === "revpar") &&
                        wrapSlot(renderSlot("revpar", _jsx(RevPARChart, { storeId: storeId, bundle: storeData.revparBundle, loading: componentStatus["revpar"] === "loading", onTitleClick: handleRevPARTitleClick, style: fullWidthStyle }))), (!focusComponentType ||
                        focusComponentType === "customer-source") &&
                        wrapSlot(renderSlot("customer-source", _jsx(CustomerSource, { storeId: storeId, bundle: storeData.customerSourceBundle, loading: componentStatus["customer-source"] === "loading", style: fullWidthStyle }))), (!focusComponentType ||
                        focusComponentType === "discount-analysis") &&
                        wrapSlot(renderSlot("discount-analysis", _jsx(DiscountAnalysis, { storeId: storeId, bundle: storeData.discountAnalysisBundle, loading: componentStatus["discount-analysis"] === "loading", style: fullWidthStyle }))), (!focusComponentType ||
                        focusComponentType === "occupancy-analysis") &&
                        wrapSlot(renderSlot("occupancy-analysis", _jsx(OccupancyAnalysis, { bundle: storeData.occupancyAnalysisBundle, style: fullWidthStyle }))), (!focusComponentType ||
                        focusComponentType === "operation-efficiency") &&
                        wrapSlot(renderSlot("operation-efficiency", _jsx(OperationEfficiency, { storeId: storeId, bundle: storeData.operationEfficiencyBundle, loading: componentStatus["operation-efficiency"] === "loading", style: fullWidthStyle }))), (!focusComponentType || focusComponentType === "channel-info") &&
                        wrapSlot(renderSlot("channel-info", _jsx(ChannelInfoChart, { storeId: storeId, bundle: storeData.channelInfoBundle, loading: componentStatus["channel-info"] === "loading", onTitleClick: handleChannelInfoTitleClick, style: fullWidthStyle }))), (!focusComponentType ||
                        focusComponentType === "channel-analysis") &&
                        wrapSlot(renderSlot("channel-analysis", _jsx(ChannelAnalysis, { storeId: storeId, bundle: storeData.channelAnalysisBundle, loading: componentStatus["channel-analysis"] === "loading", onTitleClick: handleChannelAnalysisTitleClick, style: fullWidthStyle })))] }))) })) })));
    if (bareLayout) {
        // wrapLayout 时不包外层 div，直接返回 innerContent，作为父级滚动 div 的直接子节点
        if (wrapLayout) {
            return innerContent;
        }
        return (_jsx("div", __assign({ "data-hotel-id": storeId, style: { width: "100%" } }, { children: innerContent })));
    }
    return (_jsx("div", __assign({ "data-hotel-id": storeId }, { children: _jsx(ContainerPanel, __assign({ title: titleWithLoading, onTitleClick: handleTitleClick, buttons: [
                {
                    key: "refresh",
                    icon: _jsx(ReloadOutlined, {}),
                    text: "刷新",
                    onClick: handleRefresh,
                },
            ] }, { children: innerContent })) })));
}, function (prevProps, nextProps) {
    var _a, _b, _c;
    // 自定义比较函数：只有当 storeId、refreshKey 或 storeName 改变时才重新渲染
    // 返回 true 表示 props 相等（不需要重新渲染），返回 false 表示 props 不相等（需要重新渲染）
    var storeIdEqual = prevProps.storeId === nextProps.storeId;
    var refreshKeyEqual = prevProps.refreshKey === nextProps.refreshKey;
    var storeNameEqual = prevProps.storeName === nextProps.storeName;
    var bareLayoutEqual = prevProps.bareLayout === nextProps.bareLayout;
    var wrapLayoutEqual = prevProps.wrapLayout === nextProps.wrapLayout;
    var hideStoreNameEqual = prevProps.hideStoreName === nextProps.hideStoreName;
    var draggableEqual = prevProps.draggable === nextProps.draggable;
    var componentOrderEqual = prevProps.componentOrder === nextProps.componentOrder ||
        (Array.isArray(prevProps.componentOrder) &&
            Array.isArray(nextProps.componentOrder) &&
            ((_a = prevProps.componentOrder) === null || _a === void 0 ? void 0 : _a.length) === ((_b = nextProps.componentOrder) === null || _b === void 0 ? void 0 : _b.length) &&
            ((_c = prevProps.componentOrder) === null || _c === void 0 ? void 0 : _c.every(function (v, i) { var _a; return v === ((_a = nextProps.componentOrder) === null || _a === void 0 ? void 0 : _a[i]); })));
    var propsEqual = storeIdEqual &&
        refreshKeyEqual &&
        storeNameEqual &&
        bareLayoutEqual &&
        wrapLayoutEqual &&
        hideStoreNameEqual &&
        draggableEqual &&
        componentOrderEqual;
    if (!propsEqual) {
        var storeLogger = logger.createChild("propsCompare:".concat(nextProps.storeId));
        storeLogger.debug("检测到 props 变化，将重新渲染", {
            prevStoreId: prevProps.storeId,
            nextStoreId: nextProps.storeId,
            storeIdChanged: !storeIdEqual,
            prevRefreshKey: prevProps.refreshKey,
            nextRefreshKey: nextProps.refreshKey,
            refreshKeyChanged: !refreshKeyEqual,
            prevStoreName: prevProps.storeName,
            nextStoreName: nextProps.storeName,
            storeNameChanged: !storeNameEqual,
        });
    }
    // 返回 true 表示相等（不重新渲染），false 表示不相等（重新渲染）
    return propsEqual;
    // 注意：不比较 onTitleClick、onRefresh、onComponentTitleClick、onDataLoaded
    // 因为这些回调函数每次都是新创建的，但它们不影响组件的数据
});
StoreDataLoader.displayName = "StoreDataLoader";
export default StoreDataLoader;
